import { useSelector } from 'react-redux';

import { EVENT_CONSTANTS } from '@/services';
import {
  selectUserAudienceRegions,
  selectUserCompliance,
  useFetchNewEpisodesQuery,
} from '@/store';

import { EpisodeCardVariants } from '../EpisodeCard';
import { EpisodeCardCarousel } from '../EpisodeCardCarousel';

const location = {
  page: EVENT_CONSTANTS.PAGE.DISCOVER,
};

export const NewTechnicalEpisodesCarousel = () => {
  const audienceRegions = useSelector(selectUserAudienceRegions);
  const compliance = useSelector(selectUserCompliance);

  const {
    data: newEpisodes,
    isError,
    isLoading,
    isUninitialized,
  } = useFetchNewEpisodesQuery({
    isTechnical: true,
    compliance,

    audienceRegions,
    applyRelevanceBoost: true,
  });

  return (
    <>
      {isError || !newEpisodes ? null : (
        <EpisodeCardCarousel
          title="New Technical Episodes"
          uKey="New Technical Episodes"
          episodes={newEpisodes}
          isLoading={isLoading || isUninitialized}
          variant={EpisodeCardVariants.SMALL}
          referrer={location}
        />
      )}
    </>
  );
};
